import * as React from 'react';

import a11yKeyPress from 'js/lib/a11yKeyPress';

import { color } from '@coursera/coursera-ui';
import { SvgChevronRight } from '@coursera/coursera-ui/svg';

import FilterPills from '../elements/FilterPills';
import type { FilterCtrl, FilterOption } from '../types';

export type Props = {
  filterCtrl: FilterCtrl;
  selectedFilterOptions: FilterOption[];
  onOpen: () => void;
  onChange: (selected: FilterOption[]) => void;
  className?: string;
  selectedRef?: React.Ref<HTMLDivElement>;
};

type State = {};

class FilterSelector extends React.Component<Props, State> {
  handleDelete = (id: string) => {
    const { onChange, selectedFilterOptions } = this.props;
    onChange(selectedFilterOptions.filter((fo) => fo.id !== id));
  };

  render() {
    const { filterCtrl, selectedFilterOptions, onOpen, className, selectedRef } = this.props;

    return (
      <div
        className={`rc-FilterSelector horizontal-box ${className}`}
        onClick={onOpen}
        data-testid={`${filterCtrl.type}-filter`}
        role="button"
        tabIndex={0}
        onKeyPress={(e) => a11yKeyPress(e, onOpen)}
        ref={selectedRef}
      >
        <div className="vertical-box flex-1">
          <div className="text-xs-left m-b-1s">{filterCtrl.title}</div>
          <FilterPills
            filterList={selectedFilterOptions}
            onDelete={this.handleDelete}
            emptyText={filterCtrl.emptyText}
          />
        </div>
        <div className="vertical-box align-items-vertical-center p-t-1s">
          <SvgChevronRight color={color.primary} size={32} />
        </div>
      </div>
    );
  }
}

export default FilterSelector;
